import { menuTypes } from "../_constants/menuTypes";
import { DOCTYPE } from "../_constants/docTypeConstants";

/**
 * @type {MainMenuDefaultOptions}
 * @constant
 */
export const mainMenuDefaultOptions = {
  main: [
    // {
    //   menuId: "m_1",
    //   type: menuTypes.MENU_OPTION_ROOT,
    //   preIcon: "search",
    //   label: "Search Documents",
    //   link: "",
    //   docType: "DOCTYPE.LINK",
    //   actions: ["OPEN_LINK"],
    //   isDisabled: true
    // },
    {
      menuId: "m_2",
      type: menuTypes.MENU_OPTION_ROOT,
      preIcon: "chart-pie",
      label: "Reports",
      link: "",
      docType: DOCTYPE.REPORT_SELECTION,
      actions: ["OPEN_MODAL"],
      isDisabled: false
    },
    // {
    //   menuId: "m_3",
    //   type: menuTypes.MENU_SEPARATOR,
    //   preIcon: "",
    //   label: "",
    //   link: "",
    //   docType: "DOCTYPE.LINK",
    //   actions: ["OPEN_LINK"],
    //   isDisabled: false
    // },
    // {
    //   menuId: "m_4",
    //   type: menuTypes.MENU_OPTION_ROOT,
    //   preIcon: "home",
    //   label: "SC Home",
    //   link: "",
    //   docType: "DOCTYPE.LINK",
    //   actions: ["OPEN_LINK"],
    //   isDisabled: true
    // },
    // {
    //   menuId: "m_5",
    //   type: menuTypes.MENU_OPTION_ROOT,
    //   preIcon: "eye",
    //   label: "VISION",
    //   link: "/vision",
    //   docType: "DOCTYPE.LINK",
    //   actions: ["OPEN_LINK"],
    //   isDisabled: true
    // },
    // {
    //   menuId: "m_6",
    //   type: menuTypes.MENU_OPTION_ROOT,
    //   preIcon: "cubes",
    //   label: "WEAT",
    //   link: "/weat",
    //   docType: "DOCTYPE.LINK",
    //   actions: ["OPEN_LINK"],
    //   isDisabled: true
    // },
    // {
    //   menuId: "m_7",
    //   type: menuTypes.MENU_OPTION_ROOT,
    //   preIcon: "search-plus",
    //   label: "BCM Advanced Search",
    //   link: "",
    //   docType: "DOCTYPE.LINK",
    //   actions: ["OPEN_LINK"],
    //   isDisabled: true
    // },
    {
      menuId: "m_8",
      type: menuTypes.MENU_OPTION_ROOT,
      preIcon: "th-list",
      label: "Project List",
      link: "",
      docType: DOCTYPE.PROJECT_LIST,
      actions: [],
      isDisabled: false
    }
    // {
    //   menuId: "m_9",
    //   type: menuTypes.MENU_OPTION_ROOT,
    //   preIcon: "moon",
    //   label: "Overtime",
    //   link: "",
    //   docType: "DOCTYPE.OVERTIME_LIST",
    //   actions: [],
    //   isDisabled: false
    // }
  ],
  userSpecific: []
};
